import type { ComponentType } from 'react';

export interface FaqPair {
  q: string;
  a: string;
}

export interface PostMeta {
  slug: string;
  title: string;
  date: string; // ISO YYYY-MM-DD
  excerpt: string;
  cover?: string; // ścieżka do /images/blog/...
  tags: string[];
  readTime: number; // minuty
  faq?: FaqPair[]; // pary Q&A z sekcji FAQ -> FAQPage JSON-LD schema
}

export interface PostModule {
  meta: PostMeta;
  Body: ComponentType;
}

// Eager-load all posts (małe, lokalne pliki TSX)
const modules = import.meta.glob<PostModule>('./*.tsx', { eager: true });

export const posts: PostModule[] = Object.values(modules)
  .filter((m): m is PostModule => Boolean(m?.meta))
  .sort((a, b) => b.meta.date.localeCompare(a.meta.date));

export function getPostBySlug(slug: string): PostModule | undefined {
  return posts.find(p => p.meta.slug === slug);
}

export function getAllPosts(): PostMeta[] {
  return posts.map(p => p.meta);
}
